
import { mixins } from 'vue-class-component';
import WalletMixin from '@/mixins/wallet';

export default class MinimalConnect extends mixins(WalletMixin) {}
